<template>
   <div class="bg-white loginBox">
    <van-nav-bar
        title="登录小筑教育"
        left-text="返回"
        right-text="密码登录"
        left-arrow
        @click-left="onClickLeft"
    />
    <ul class="ft14 row cen-center text-center">
        <li @click="selectLogin(index)" class="col-12 btnBox btn" v-for="(item, index) in loginList" :class="{'selBtnBox':cur==index}" :key="index">{{item}}</li>
    </ul>
    <note-login v-if="cur == 0"></note-login>
    <pwd-login v-if="cur == 1"></pwd-login>
   </div>
</template>

<script>
import NoteLogin from './noteLogin';
import PwdLogin from './pwdLogin';
export default {
  name: 'Home',
  data(){
      return {
         loginList:['短信登录','密码登录'],
         cur:0
      }
  },
  components: {
    NoteLogin,
    PwdLogin,
  },
    created() {
        window.scrollTo(0,0);
    },
  methods:{
      selectLogin(index){
          this.cur = index
      },
  }
}
</script>
<style scoped lang='less'>
.loginBox{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}
.btn{
    height:45/20rem;
    line-height:45/20rem;
}
.btnBox{
    background:rgba(246,246,246,1);
    color:#222;
}
.selBtnBox{
    background:rgba(255,255,255,1);
    color:#F08243;
}
</style>

